import { Event, events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { reduceZone } from "../../common/zone";
import { reduceProject } from "../../common/project";
import { initialState } from "./initialState";
import { handleZoneRemoval } from "./removeZoneSucceeded";
import { handleZoneCreation } from "./createZoneSucceeded";
import { handleRequest } from "./retrieveZonesRequested";
import { handleSuccess } from "./retrieveZonesSucceeded";
import { handleFailure } from "./retrieveZonesFailed";
import { handleCreateProject } from "./createProject";
import { handleRemoveProject } from "./removeProject";
import { handleDuplicateProject } from "./duplicateProject";
import { handleTransferProjects } from "./transfertProjects";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

function propagateEvent(state = initialState, event: Event): State {
  return state.map(
    (req) => ({
      ...req,
      zones: req.zones.map((zone) => ({
        ...reduceZone(zone, event),
        projects: zone.projects.map((project) => reduceProject(project, event)),
      })),
    }),
    {},
  );
}

const reduceState = resetState(
  initialState,
  createStateReducer(
    initialState,
    {
      [events.retrieveZonesRequested]: handleRequest,
      [events.retrieveZonesSucceeded]: handleSuccess,
      [events.retrieveZonesFailed]: handleFailure,
      [events.createZoneSucceeded]: handleZoneCreation,
      [events.removeZoneSucceeded]: handleZoneRemoval,
      [events.createProjectSucceeded]: handleCreateProject,
      [events.removeProjectSucceeded]: handleRemoveProject,
      [events.duplicateProjectSucceeded]: handleDuplicateProject,
      [events.transferProjectsSucceeded]: handleTransferProjects,
    },
    propagateEvent,
  ),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
